var map = {
	"./base2/img/banner/banner-mobile.png": "ca28",
	"./base2/img/banner/loto-4-59-luckia-mobile.png": "6971",
	"./base2/img/banner/loto-4-59-mobile.png": "4d73",
	"./base2/img/banner/lotto-5-45-mobile.png": "e348",
	"./base2/img/banner/lotto-6-45-mobile.png": "e072",
	"./default/img/banner/banner-mobile.png": "bb1a",
	"./default/img/banner/loto-4-59-luckia-mobile.png": "a386",
	"./default/img/banner/loto-4-59-mobile.png": "74cc",
	"./default/img/banner/lotto-5-45-mobile.png": "d231",
	"./default/img/banner/lotto-6-45-mobile.png": "43a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afc6";